<template>
  <router-view></router-view>
</template>

<script>
import {mapGetters} from "vuex";
export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters({
            login: "login",
            unauthorized: "unauthorized",
        }),
    },
    watch:{
        unauthorized (val) {
            if(val){
                this.logout();
            }
        },
        $route(val,oldVal){
            try {
                if(val != oldVal && oldVal.name == 'Login'){
                    localStorage.removeItem('LS_ROUTE_KEY');
                }
                if(val.name != 'visitorManagement' && val.name != 'visitor' && val.name != 'addGroupManagement'){
                    this.$store.commit('setVisitorId', null);
                    localStorage.removeItem('visitorId');
                    this.$store.commit('setFormID', null);
                    localStorage.removeItem('formID');
                }
                if(val.name == 'Login' || val.name == 'signUp'){
                    this.$store.commit('setType',null);
                    // localStorage.removeItem('login');
                    this.$store.commit('setFromPath',null);
                    this.$store.commit('setVisitorId',null);
                    localStorage.removeItem('FROM_PATH');
                    localStorage.removeItem('visitorId');
                    localStorage.removeItem('type');
                }else{
                    if(this.login && this.login.token){
                        this.$store.commit('setFromPath',{path: val.path, name: val.name});
                    }
                }
            }catch (e) {
                console.log('error', e);
            }
        }
    },
    methods: {
        logout(){
            this.$store.commit("setLogin", {
                token: null,
                expires_in: null,
                loginTime: null
            });
            if(this.$route.name != 'Login'){
                return this.$router.push({name: 'Login'});
            }
        }
    }
  }
</script>
